export const deleteHotel = async (id: number) => {
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}${process.env.REACT_APP_DELETE_HOTEL}`, {
    method: 'DELETE',
    body: JSON.stringify({id: id}),
  });
  const data = await response.text();
}